var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-badge',{attrs:{"color":_vm.getColor(),"content":_vm.getText()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }